import NAME from "./constants";

export const getIsLoading = store => store[NAME].isLoading;
export const getMyCertificateList = store => store[NAME].myCertificateList;
export const getReceiverList = store => store[NAME].receiverList;
export const getMyReceiptsList = store => store[NAME].myReceiptsList;